import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";

import LayoutReducer from "./layouts/reducer";

import LoginReducer from "./auth/login/reducer";

import UsersReducer from "./users/reducer";

import OrdersReducer from "./orders/reducer";

import DashboardReducer from "./dashboard/reducer";
import DashboardStatsReducer from "./dashboardStats/reducer";

import CustomersReducer from "./customers/reducer";
import NotificationsReducer from "./notifications/reducer";
import PaymentFormsReducer from "./paymentForms/reducer";
import PaymentMethodsReducer from "./paymentMethods/reducer";
import ProductsReducer from "./products/reducer";

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Users: UsersReducer,
  Orders: OrdersReducer,
  Dashboard: DashboardReducer,
  DashboardStats: DashboardStatsReducer,
  Customers: CustomersReducer,
  PaymentMethods: PaymentMethodsReducer,
  PaymentForms: PaymentFormsReducer,
  Products: ProductsReducer,
  Notifications: NotificationsReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

import persistConfig from "./persistConfig";

const persistedReducer = persistReducer<RootState>(persistConfig, rootReducer);

export default persistedReducer;
